<template>
  <div class="container pb-40" style="margin-top: 7px;">
    <TopGradientBlockLayout>
      <template v-slot:top>
        <div class="flex items-center" v-if="!formOpen">
          <BaseButton v-if="!currentUserIsWatcher" theme="red" class="lg:w-78" @click="formOpen = true">
            {{ $t('newGoal') }}
          </BaseButton>
          <BaseSelect v-model="groupType"
                      :options="groupTypesList"
                      :select-label="$t('groupBy')"
                      :label="`name_${$i18n.locale}`"
                      class="flex-none ml-auto"
                      :allow-empty="false"/>
          <BaseCheckbox v-if="userHasCompletedGoals" class="ml-12"
                        :checked="displayCompletedGoals"
                        @change="displayCompletedGoals = !displayCompletedGoals">
            {{ $t('showCompleted') }}
          </BaseCheckbox>
        </div>
        <GoalCreateForm v-else @finish="finishCreateGoal"/>
      </template>
      <GoalsList :goals-list="goalsList"
                 :dirty="goals.dirty"
                 :show-finished="displayCompletedGoals"
                 :list-structure-id="groupType.id || 0"/>
    </TopGradientBlockLayout>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";
import BaseButton from "@/components/UI/BaseButton";
import BaseSelect from "@/components/UI/BaseSelect/BaseSelect";
import GoalCreateForm from "@/components/cabinet/Money/Goals/GoalCreate/GoalCreateForm";
import GoalTile from "@/components/cabinet/Money/Goals/GoalTile";
import GoalsList from "@/components/cabinet/Money/Goals/GoalsList";
import BaseCheckbox from "@/components/UI/BaseCheckbox";

export default {
  name: "TheGoals",
  components: {
    BaseCheckbox,
    GoalsList,
    GoalTile,
    GoalCreateForm,
    BaseSelect,
    BaseButton,
    TopGradientBlockLayout
  },
  data() {
    return {
      groupType: null,
      displayCompletedGoals: true,
      formOpen: false,
    }
  },
  computed: {
    ...mapState('space/goals', ['goals']),
    ...mapGetters('space', ['currentUserIsWatcher']),
    ...mapGetters('space/goals', ['goalsList']),
    groupTypesList() {
      return [
        {name_en: 'No group', name_ru: 'Без группировки', id: 0},
        {name_en: 'Type', name_ru: 'По типу', id: 1},
        {name_en: 'Year', name_ru: 'По годам', id: 2}]
    },
    userHasCompletedGoals() {
      return !!this.goalsList.find(goal => goal.status === 2)
    }
  },
  methods: {
    finishCreateGoal() {
      this.formOpen = false;
      this.$store.dispatch('space/goals/fetchUserGoals');
    },
  },
  beforeCreate() {
    this.$store.dispatch('space/goals/fetchUploadedGoalsImages');
  },
  created() {
    this.groupType = this.groupTypesList[0];
    this.$store.dispatch('space/accounts/getAccounts');
    this.$store.dispatch('space/accounts/getAccountGroups');
    this.$store.dispatch('space/expenses/getExpenses');
    this.$store.dispatch('space/expenses/getExpenseGroups');
    this.$store.dispatch('space/incomes/getIncomes');
    this.$store.dispatch('space/tags/getTags');
    this.$store.dispatch('space/contractors/getContractors');
    this.$store.dispatch('space/goals/fetchUserGoals');
  },
  i18n: {
    messages: {
      en: {
        newGoal: 'New goal',
        groupBy: 'Group by',
        showCompleted: 'Show completed'
      },
      ru: {
        newGoal: 'Новая цель',
        groupBy: 'Группировка',
        showCompleted: 'Показать завершенные'
      },
    }
  }
}
</script>